import { z } from 'zod';

export const adContentSchema = z.object({
  title: z.string().min(1, 'Title is required').max(200),
  notes: z.string().optional(),
  redirectUrl: z.string().url('Must be a valid URL').min(1, 'Redirect URL is required'),
});

export type AdContentFormValues = z.infer<typeof adContentSchema>;
